// Full-document render of the stearns TempurLoveStoryPage: PageSkeleton (the
// React document shell) wrapping the tempur-love header and the existing
// story-page body assembly. Both are gated on love_root -- the header matched
// the legacy partial's {% if love_root %}, and the body island's props require
// a non-null love_root (story pages only exist under a TempurLoveRootPage).
import React from "react";

import { templates } from "@reactivated";

import { TempurLoveStoryPage as TempurLoveStoryPageBody } from "../apps/tempur-love/TempurLoveStoryPage";
import { PageSkeleton } from "../components/PageSkeleton";
import { TempurLoveHeader } from "../components/TempurLoveHeader";

export const Template = (
    props: templates.TempurLoveStoryPageDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        {props.love_root && (
            <>
                <TempurLoveHeader love_root={props.love_root} />
                <TempurLoveStoryPageBody
                    {...props}
                    love_root={props.love_root}
                />
            </>
        )}
    </PageSkeleton>
);
